const Email = (props: { fill: string }) => {
	return (
		<>
			<path
				d="M21 6.8C21 5.81 20.19 5 19.2 5H4.8C3.81 5 3 5.81 3 6.8V17.6C3 18.59 3.81 19.4 4.8 19.4H19.2C20.19 19.4 21 18.59 21 17.6V6.8ZM19.2 6.8L12 11.3L4.8 6.8H19.2ZM19.2 17.6H4.8V8.6L12 13.1L19.2 8.6V17.6Z"
				fill={props.fill}
			/>
		</>
	);
};

export default Email;
